import styled from "styled-components";

import { Typo } from "@enkor/design/components";
import { getOpacityColor, grayScale, red } from "@enkor/design/colors";
import { removeScrollbar } from "@enkor/design/mixins";

export const Container = styled.div`
  padding: 16px;
`;

export const CommentHeader = styled.div`
  display: flex;
  justify-content: space-between;

  margin-bottom: 12px;
`;

export const HeaderTitle = styled(Typo.Text)`
  display: inline-block;
`;

export const CommentFormBox = styled.form`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: flex-end;
`;

export const CommentTextarea = styled.textarea`
  width: 100%;
  height: 48px;
  max-height: 100px;
  padding: 11px 16px;
  border: 1px solid ${grayScale.main};
  border-radius: 24px;

  background-color: ${getOpacityColor(grayScale.black, 0.2)};

  color: ${grayScale.white};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  resize: none;

  transition: all 0.3s ease-in-out;

  &:focus {
    border: 1px solid ${grayScale.white};
  }

  &::placeholder {
    color: ${grayScale.main};
  }

  ${removeScrollbar}
`;

export const CommentSendButton = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 50%;

  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${getOpacityColor(grayScale.white, 0.1)};
  }

  &:disabled,
  &:disabled:hover {
    background-color: transparent;

    cursor: default;
  }
`;

export const InputErrorMessage = styled(Typo.Text)`
  margin-top: 8px;

  color: ${red.main};
`;
